export const Key_Header_FIN = {
  IDFIN: 'IDFIN',
  EXTEN: 'EXTEN',
  NAMFI: 'NAMFI',
  ANNEX: 'ANNEX',
  CODEF: 'CODEF',
  DESCR: 'DESCR',
  NOREV: 'NOREV',
  APPR1: 'APPR1',
  APPR2: 'APPR2',
  APPR3: 'APPR3',
  APPR4: 'APPR4',
  DAMOD: 'DAMOD',
  DACRE: 'DACRE',
  DAEXP: 'DAEXP',
  STATU: 'STATU',
  CONTR: 'CONTR',
  AREA_: 'AREA_',
  SHOP_: 'SHOP_',
}
